export default __webpack_public_path__ + "static/media/kafka.6b191339.svg";